import React, { Component } from 'react';
import AD from 'react-google-publisher-tag';
import _ from 'lodash';
import { player_stats_info, player_stats_info_bis } from '~/tools/mll/headers';
import Table from '~/components/Table';
import Spinner from '~/components/Spinner';
import './PlayerInfo.css';

class PlayerInfo extends Component {
  state = {
    headers: player_stats_info,
    season_stats: []
  }

  componentDidMount = () => {
    if (this.props.api) {
      this.getDataFromApi(this.props.api);
    }
  }

  componentWillReceiveProps = (props) => {
    this.getDataFromApi(props.api);
  }

  getDataFromApi = (props) => {
    let season_stats = props.data.playerData.playerStats;

    // temporary hacky ugly fix
    if (season_stats.hasOwnProperty('seasonStats')) {
      if (Array.isArray(season_stats.seasonStats)) {
        const regular = season_stats.seasonStats.filter(el => el.type === 'Regular');
        const playoffs = season_stats.seasonStats.filter(el => el.type === 'Playoffs');
        season_stats = [regular, playoffs];
      } else {
        season_stats = [[season_stats.seasonStats]];
      }
      this.setState({ headers: player_stats_info_bis })
    } else {
      season_stats = [_.get(season_stats, 'regular', []), _.get(season_stats, 'playoff', [])];
    }    
    this.setState({ 
      season_stats
    })
  }

  render() {
    return (
      <div>
        { this.state.season_stats.length ? this.state.season_stats.map((stats, i) => (
          <div className='playerinfo-wrapper' key={i}>
            <h3 className='playerinfo-season site-border-color'>{i < 1 ? 'Regular Season' : 'Playoffs'}</h3>
            <Table 
              key={i}
              headers={this.state.headers[0]}
              data={stats}
              values={this.state.headers[1]}
            />
          </div>
        )) : <Spinner /> }
        <div className="banner-ad-container">
          <AD path={_.get(this.props.data, 'metadataMap.bannerAdTag')} dimensions={[[970,90],[728,90],[320,50]]}/>
        </div>
      </div>
    )
  }
}

export default PlayerInfo;
